import { ForgotPasswordQueryParams } from '../../../components/pages/authentication/ForgotPassword/ForgotPasswordForm/ForgotPasswordForm.types';
import { UpdatePasswordQueryParams } from '../../../components/pages/authentication/ForgotPassword/NewPasswordForm/NewPasswordForm.types';
import { InitPasswordQueryParams } from '../../../components/pages/authentication/InitPassword/InitPasswordForm/InitPasswordForm.types';
import { RegisterNAFProspectQueryParams } from '../../../components/pages/connected/Dashboard/DashboardProspections/DashboardProspectionsTable/ValidatePaymentModal/ProspectPaymentForm/ProspectPaymentForm.types';
import { ProfileAccountFormSchema } from '../../../components/pages/connected/Profile/ProfileAccount/ProfileAccountForm/ProfileAccountForm.types';
import { ProfileAccountFormCOMSchema } from '../../../components/pages/connected/Profile/ProfileAccount/ProfileAccountFormCOM/ProfileAccountFormCOM.types';
import { ProfileCredentialsFormSchema } from '../../../components/pages/connected/Profile/ProfileCredentials/ProfileCredentialsForm/ProfileCredentialsForm.types';
import { ProfilePasswordFormSchema } from '../../../components/pages/connected/Profile/ProfilePassword/ProfilePasswordForm/ProfilePasswordForm.types';
import { UseForgotPasswordDataParams } from '../../../hooks/fetchers/useForgotPasswordData/useForgotPasswordData.types';
import { UseSignaturePaymentENTParams } from '../../../hooks/fetchers/useSignaturePaymentENT/useSignaturePaymentENT.types';
import { CreateUserParams } from '../../../types/api/endpoints/auth/createUser.types';
import { LoginParams } from '../../../types/api/endpoints/auth/login.types';
import {
  CompanyRequestData,
  EntityRequestData,
  NAFRequestData,
  SignUpENTRequestData,
  SignUpProspectENTRequestData,
  SignUpRequestData,
  UserRequestData,
} from '../../../types/api/endpoints/auth/register.types';
import {
  StaticGetEndpoints,
  StaticPostEndpoints,
} from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const AUTH_ENDPOINTS = Object.freeze({
  login: (params: LoginParams) => api.post(StaticPostEndpoints.Login, params),
  loginCommercial: (params: LoginParams) => api.post(StaticPostEndpoints.LoginCommercial, params),
  loginDIR: (params: LoginParams) => api.post(StaticPostEndpoints.LoginDIR, params),
  loginENT: (params: LoginParams) => api.post(StaticPostEndpoints.LoginENT, params),
  loginPUB: (params: LoginParams) => api.post(StaticPostEndpoints.LoginPUB, params),

  update: (params: ProfileAccountFormSchema) => api.put(StaticPostEndpoints.UpdateUser, params),
  updateCOM: (params: ProfileAccountFormCOMSchema) =>
    api.put(StaticPostEndpoints.UpdateUserCOM, params),
  updateCredentials: (params: ProfileCredentialsFormSchema) =>
    api.put(StaticPostEndpoints.UpdateUserCredentials, params),
  updateUserPassword: (params: ProfilePasswordFormSchema) =>
    api.put(StaticPostEndpoints.UpdateUserPassword, params),

  checkToken: () => api.get(StaticGetEndpoints.CheckToken),

  createUser: ({ variant, user }: CreateUserParams) => api.post(`/auth/create/${variant}`, user),

  forgotPassword: ({ email, role }: ForgotPasswordQueryParams) =>
    api.post(`/auth/password/forgot/${role}`, { email }),
  getForgotPasswordData: ({ role, hash }: UseForgotPasswordDataParams) =>
    api.get(`/auth/password/forgot/${role}/${hash}`),
  updatePassword: ({ password, role, hash }: UpdatePasswordQueryParams) =>
    api.put(`/auth/password/new/${role}/${hash}`, { password }),

  initPassword: ({ commercialId, hash, password }: InitPasswordQueryParams) =>
    api.put(`/auth/password/init/${commercialId}/${hash}`, { password }),

  deleteUser: () => api.delete(`/auth/delete`),

  signUp: ({ role, ...data }: SignUpRequestData) => api.post(`/auth/register/${role}/signup`, data),
  signUpENT: (data: SignUpENTRequestData) => api.post(StaticPostEndpoints.SignUpENT, data),
  signUpProspectENT: (data: SignUpProspectENTRequestData) =>
    api.post(StaticPostEndpoints.SignUpProspectENT, data),

  entity: (data: EntityRequestData) => api.post(`/auth/register/PUB/entity`, data),

  user: (data: UserRequestData) => api.post(`/auth/register/PUB/user`, data),

  company: (data: CompanyRequestData) => api.post(`/auth/register/ENT/company`, data),
  logoENT: (data: FormData) =>
    api.post(StaticPostEndpoints.UploadLogo, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  removeLogoENT: () => api.delete(StaticPostEndpoints.RemoveLogo),
  document: (data: FormData) =>
    api.post(StaticPostEndpoints.UploadKBIS, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  documentPUB: (data: FormData) =>
    api.post(StaticPostEndpoints.UploadDocPUB, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),

  fieldsOfActivity: (data: NAFRequestData) => api.post(`/auth/register/ENT/NAF`, data),
  fieldsOfActivityAndTransactions: (data: UseSignaturePaymentENTParams) => api.post(`/auth/register/ENT/NAF_and_transactions`, data),
  oldFieldsOfActivityProspect: (data: NAFRequestData & { prospectId: number }) => api.post(`/auth/register/prospect/NAF`, data),
  fieldsOfActivityProspect: (data: RegisterNAFProspectQueryParams) => api.post(`/auth/register/prospect/NAF`, data),
});
